import { combineLatest, take } from "rxjs";
import { EditionFeatureService } from "@webapp/accounts/services/edition-feature.service";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { AlignmentType } from "@webapp/sessions/models/session-tree.model";
import { SessionSelectorUtilsService } from "../session-selector-utils.service";
import { AbstractSessionTreeBuilder } from "./abstract-session-tree-builder";
import { GrandparentAlignmentSessionTreeBuilder } from "./grand-parent-alignment-session-tree-builder";
import { ParentAlignmentSessionTreeBuilder } from "./parent-alignment-session-tree-builder";

export class SessionTreeBuilderFactory {
  private readonly buildersMap = {
    "grandparent-alignment": GrandparentAlignmentSessionTreeBuilder,
    "parent-alignment": ParentAlignmentSessionTreeBuilder,
  };
  private builderType: AlignmentType;

  constructor(
    private sessionSelectorUtilsService: SessionSelectorUtilsService,
    private featureTogglesFacade: FeatureTogglesFacade,
    private editionFeatureService: EditionFeatureService
  ) {
    // todo remove request for FeatureFlag.GrandParentAlignment
    combineLatest([
      this.featureTogglesFacade.isFeatureAvailable$(FeatureFlag.GrandParentAlignment),
      this.editionFeatureService.hasFeature$("grandparent-session-alignment"),
    ])
      .pipe(take(1))
      .subscribe(([isAvailable, hasFeature]) => {
        this.builderType = isAvailable && hasFeature ? "grandparent-alignment" : "parent-alignment";
      });
  }

  public createTreeBuilder(): AbstractSessionTreeBuilder {
    return new this.buildersMap[this.builderType](this.sessionSelectorUtilsService);
  }
}
